










import { Component, Vue } from 'vue-property-decorator';

import JobList from '@/components/jobSummary/JobList.vue';

@Component({
  components: {
    JobList
  }
})
export default class Home extends Vue {

}
